import {
  HousingIntakeScenarioStatus,
  HousingApplicationStatus,
  HousingIntakeScenarioProcessedApplicationStatus,
} from "~/api";
import { housingApplicationStatusDisplayNamesHMBSite } from "./enumDisplayNames";

import type { EnumDescriptionDict } from "~/utils/enumDescriptions";

export const housingIntakeSenarioStatusDescriptions: EnumDescriptionDict<HousingIntakeScenarioStatus> =
  {
    [HousingIntakeScenarioStatus.DRAFT]: {
      label: "Draft",
      description: "This scenario has not yet been activated.",
      tagType: "info",
    },
    [HousingIntakeScenarioStatus.OPEN]: {
      label: "Open",
      description: "This unit is open for seniors to move in.",
      tagType: "success",
    },
    [HousingIntakeScenarioStatus.CLOSED]: {
      label: "Closed",
      description: "This unit already has an offer accepted by a senior.",
      tagType: "danger",
    },
    [HousingIntakeScenarioStatus.ARCHIVED]: {
      label: "Archived",
      tagType: "info",
    },
    [HousingIntakeScenarioStatus.MIGRATED]: {
      label: "Migrated",
      description:
        "Legacy scenario frozen in place. In-progress work can continue.",
      tagType: "warning",
    },
  };

export const housingIntakeScenarioApplicationStatusDescriptions: EnumDescriptionDict<HousingIntakeScenarioProcessedApplicationStatus> =
  {
    [HousingIntakeScenarioProcessedApplicationStatus.INTAKE]: {
      label: "Interviewing",
      tagType: "primary",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.INTERVIEWING]: {
      label: "Interviewing",
      tagType: "primary",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.OFFER_IN_PROGRESS]: {
      label: "Offer in Progress",
      tagType: "warning",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.ACCEPTED]: {
      label: "Offer Accepted",
      tagType: "success",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.REJECTED]: {
      label: "Strike",
      tagType: "danger",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.THIRD_STRIKE]: {
      label: "3rd Strike",
      tagType: "danger",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.NO_OFFER]: {
      label: "No Offer",
      tagType: "info",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.NO_OFFER_CANCELLED]: {
      label: "No Offer - Cancelled",
      description:
        "This applicant was originally marked as No Offer but that was reverted.",
      tagType: "info",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.CANCELLED]: {
      label: "Cancelled",
      tagType: "info",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.INELIGIBLE]: {
      label: "Ineligible",
      tagType: "info",
    },
    [HousingIntakeScenarioProcessedApplicationStatus.OFFER_REJECTED]: {
      label: "Offer Rejected",
      description: "This applicant rejected an offer.",
      tagType: "warning",
    },
  };

export const housingApplicationStatusDescriptions: EnumDescriptionDict<HousingApplicationStatus> =
  {
    [HousingApplicationStatus.DRAFT]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.DRAFT
        ]!,
      bgColor: "#f4f4f5",
      fontColor: "#909399",
    },
    [HousingApplicationStatus.NEW]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.NEW
        ]!,
      bgColor: "#fef0f0",
      fontColor: "#e79bcb",
    },
    [HousingApplicationStatus.IN_REVIEW]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.IN_REVIEW
        ]!,
      bgColor: "#efe3ff",
      fontColor: "#ba83f1",
    },
    [HousingApplicationStatus.WAITLIST]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.WAITLIST
        ]!,
      bgColor: "#ecf5ff",
      fontColor: "#409eff",
    },
    [HousingApplicationStatus.ON_HOLD]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.ON_HOLD
        ]!,
      tagType: "warning",
    },
    [HousingApplicationStatus.CANCELLED]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.CANCELLED
        ]!,
      tagType: "danger",
    },
    [HousingApplicationStatus.LOCKED_INTERVIEWING]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.LOCKED_INTERVIEWING
        ]!,
      bgColor: "#d1ecf1",
      fontColor: "#17a2b8",
    },
    [HousingApplicationStatus.LOCKED_WITH_OFFER]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.LOCKED_WITH_OFFER
        ]!,
      bgColor: "#d1ecf1",
      fontColor: "#17a2b8",
    },
    [HousingApplicationStatus.OFFER_ACCEPTED]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.OFFER_ACCEPTED
        ]!,
      tagType: "success",
    },
    [HousingApplicationStatus.HOUSED]: {
      label:
        housingApplicationStatusDisplayNamesHMBSite[
          HousingApplicationStatus.HOUSED
        ]!,
      bgColor: "#d4edda",
      fontColor: "#67c23a",
    },

    // Redundant statuses - required until we remove them from the system which will be after the migrations.
    [HousingApplicationStatus.SUBMITTED]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.ASSIGNED]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.PRSCOMPLETED]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.INTAKE]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.OFFER_ACTIVE]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.WAITLISTED]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.OFFER_REJECTED]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
    [HousingApplicationStatus.CANCELED]: {
      label: "",
      description: undefined,
      tagType: undefined,
      bgColor: undefined,
      fontColor: undefined,
    },
  };

export const enumDescriptions = {
  housingIntakeScenarioStatus: housingIntakeSenarioStatusDescriptions,
  // housingIntakeStatus: housingIntakeStatusDescriptions,
  housingApplicationStatus: housingApplicationStatusDescriptions,
};
